
import React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';

import {
    DialogAlert,
    DialogConfirm,
    IfComp,
    ToolbarCommandButton
} from '../../../core';

import { useDisableEditMsg } from '../../../project';

import DialogDocumentLink from './DialogDocumentLink';

const Document = ({
    dataActions,
    item,
    projectId,
    readOnly,
    token
}) => {

    const classNames = mergeStyleSets({
        link: {
            width: 230, // ToDo: fixed width is not the best
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    });

    const disableEditMsg = useDisableEditMsg();

    const handleDelete = async () => {
        if (!disableEditMsg) {
            const confirm = await DialogConfirm.show(`Opravdu chcete smazat tento odkaz na dokument: "${item.title}" ?`)
            if (confirm) {
                dataActions.deleteDocument(
                    token, projectId,
                    {
                        gid: item.gid
                    }
                );
            }
        } else {
            DialogAlert.show(disableEditMsg);
        }
    }

    const handleEdit = async () => {
        if (!disableEditMsg) {
            let res = await DialogDocumentLink.show(item.url, item.title, item.description);
            if (res) {
                dataActions.updateDocument(
                    token, projectId,
                    {
                        gid: item.gid,
                        url: res.url,
                        title: res.title,
                        description: res.description
                    }
                );
            }
        } else {
            DialogAlert.show(disableEditMsg);
        }
    }

    const getTitle = () => {
        return (item.description)
            ? `${item.url}\r\n\r\n${item.description}`
            : `${item.url}`;
    }

    const getText = () => {
        return `${item.title}`;
    }

    return (
        <Stack horizontal verticalAlign="center" tokens={{childrenGap: 5}}>
            <FontIcon iconName="LocationDot" />
            <Stack.Item grow>
                <Stack horizontal className={classNames.link}>
                    <Link href={item.url} title={getTitle()} target="external">{getText()}</Link>
                </Stack>
            </Stack.Item>
            <IfComp cond={!readOnly}>
                <ToolbarCommandButton
                    items={[{
                        title: 'Upravit odkaz na dokument',
                        icon: 'Edit',
                        onClick: handleEdit,
                        styles: {root: {height: 20}, icon: {padding: 0, margin: 0}}
                    }, {
                        title: 'Odstranit odkaz na dokument',
                        icon: 'Delete',
                        onClick: handleDelete,
                        styles: {root: {height: 20}, icon: {padding: 0, margin: 0}}
                    }]}
                />
            </IfComp>
        </Stack>
    );
}

export default Document;
